import { createContext, useContext } from "react";
import { AlertProps } from "@mui/material";

export type DeepDiveToastData =
  | {
      type: "event";
      message: string;
      severity: AlertProps["severity"];
      requestId: string;
      status: string;
      eventId: string;
      eventName?: string;
      sourceDomain?: string;
    }
  | {
      type: "topic";
      message: string;
      severity: AlertProps["severity"];
      requestId: string;
      status: string;
      topic: string;
    };

interface DeepDiveToastContextType {
  showEventDeepDiveToast: (
    eventId: string,
    eventName?: string,
    sourceDomain?: string,
  ) => void;
  showTopicDeepDiveToast: (topic: string) => void;
  currentDeepDiveToast: DeepDiveToastData | null;
  clearDeepDiveToast: () => void;
}

export const DeepDiveToastContext = createContext<
  DeepDiveToastContextType | undefined
>(undefined);

export const useDeepDiveToast = () => {
  const context = useContext(DeepDiveToastContext);
  if (context === undefined) {
    throw new Error(
      "useDeepDiveToast must be used within a DeepDiveToastProvider",
    );
  }
  return context;
};
